import axios from 'axios'
import { BASE_URL } from '../../constants/config'

async function listFeeds(token, limit, skip) {
    const options = {
        method: 'get',
        headers: {
            'Authorization': `JWT ${token}`
        },
        params: {
            limit,
            skip
        },
        url: `${BASE_URL}/admin/feed`
    }
    return axios(options)
}

async function getFeed(token, feedId) {
    const options = {
        method: 'get',
        headers: {
            'Authorization': `JWT ${token}`
        },
        url: `${BASE_URL}/admin/feed/${feedId}`
    }
    return axios(options)
}

async function updateFeedStatus(token, feedId, status) {
    const options = {
        method: 'put',
        headers: {
            'Authorization': `JWT ${token}`
        },
        data: {
            status
        },
        url: `${BASE_URL}/admin/feed/${feedId}`
    }
    return axios(options)
}
export default {
    listFeeds,
    getFeed,
    updateFeedStatus
}